module.exports = __webpack_public_path__ + "static/media/SFProText-Light.359f126c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-Light.ttf
// module id = 2547
// module chunks = 7